const Football_Matches = [
  {
    id: 1,
    teams: [
      { team_name: "Stade Bordelais", team_score: 3 },
      {
        team_name: "Nantes II",
        team_score: 3,
      },
    ],
    bet: [
      { id: 1, bet_value: 1.5, name: "Arsenal" },
      { id: 3, bet_value: 4.45, name: "draw" },
      { id: 2, bet_value: 2.75, name: "Everton" },
    ],
    bonus_number: 336,
  },
  {
    id: 2,
    teams: [
      { team_name: "Stade Bordelais", team_score: 3 },
      {
        team_name: "Nantes II",
        team_score: 3,
      },
    ],
    bet: [
      { id: 1, bet_value: 1.5, name: "Arsenal" },
      { id: 3, bet_value: 4.45, name: "draw" },
      { id: 2, bet_value: 2.75, name: "Everton" },
    ],
    bonus_number: 336,
  },
  {
    id: 3,
    teams: [
      { team_name: "Stade Bordelais", team_score: 3 },
      {
        team_name: "Nantes II",
        team_score: 3,
      },
    ],
    bet: [
      { id: 1, bet_value: 1.5, name: "Arsenal" },
      { id: 3, bet_value: 4.45, name: "draw" },
      { id: 2, bet_value: 2.75, name: "Everton" },
    ],
    bonus_number: 336,
  },
];

const Tennis_Matches = [
  {
    id: 1,
    teams: [
      { team_name: "Stade Bordelais", team_score: 3 },
      {
        team_name: "Nantes II",
        team_score: 3,
      },
    ],
    bet: [
      { id: 1, bet_value: 1.5, name: "Arsenal" },
      { id: 3, bet_value: 4.45, name: "draw" },
      { id: 2, bet_value: 2.75, name: "Everton" },
    ],
    bonus_number: 336,
  },
  {
    id: 2,
    teams: [
      { team_name: "Stade Bordelais", team_score: 3 },
      {
        team_name: "Nantes II",
        team_score: 3,
      },
    ],
    bet: [
      { id: 1, bet_value: 1.5, name: "Arsenal" },
      { id: 3, bet_value: 4.45, name: "draw" },
      { id: 2, bet_value: 2.75, name: "Everton" },
    ],
    bonus_number: 336,
  },
  {
    id: 3,
    teams: [
      { team_name: "Stade Bordelais", team_score: 3 },
      {
        team_name: "Nantes II",
        team_score: 3,
      },
    ],
    bet: [
      { id: 1, bet_value: 1.5, name: "Arsenal" },
      { id: 3, bet_value: 4.45, name: "draw" },
      { id: 2, bet_value: 2.75, name: "Everton" },
    ],
    bonus_number: 336,
  },
];

const Basketball_Matches = [
  {
    id: 1,
    teams: [
      { team_name: "Stade Bordelais", team_score: 3 },
      {
        team_name: "Nantes II",
        team_score: 3,
      },
    ],
    bet: [
      { id: 1, bet_value: 1.5, name: "Arsenal" },
      { id: 3, bet_value: 4.45, name: "draw" },
      { id: 2, bet_value: 2.75, name: "Everton" },
    ],
    bonus_number: 336,
  },
  {
    id: 2,
    teams: [
      { team_name: "Stade Bordelais", team_score: 3 },
      {
        team_name: "Nantes II",
        team_score: 3,
      },
    ],
    bet: [
      { id: 1, bet_value: 1.5, name: "Arsenal" },
      { id: 3, bet_value: 4.45, name: "draw" },
      { id: 2, bet_value: 2.75, name: "Everton" },
    ],
    bonus_number: 336,
  },
  {
    id: 3,
    teams: [
      { team_name: "Stade Bordelais", team_score: 3 },
      {
        team_name: "Nantes II",
        team_score: 3,
      },
    ],
    bet: [
      { id: 1, bet_value: 1.5, name: "Arsenal" },
      { id: 3, bet_value: 4.45, name: "draw" },
      { id: 2, bet_value: 2.75, name: "Everton" },
    ],
    bonus_number: 336,
  },
];

export { Football_Matches, Tennis_Matches, Basketball_Matches };
